import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type ContactCreateRequest = {
  contact: {
    id: number;
    contact_category_code: string;
    support_service_ids?: number[];
    company_name: string;
    company_name_kana: string;
    department: string;
    position: string;
    name: string;
    name_kana: string;
    email: string;
    email_confirmation: string;
    phone: string;
    message: string;
    privacy_policy_agreed: boolean;
  };
};

export type ContactCreateResponse = {
  reception_number: string;
  received_at: string;
};

export type ContactCreateErrorResponse = {
  contact: {
    id?: string[];
    contact_category_code?: string[];
    support_service_ids?: string[];
    company_name?: string[];
    company_name_kana?: string[];
    department?: string[];
    position?: string[];
    name?: string[];
    name_kana?: string[];
    email?: string[];
    email_confirmation?: string[];
    phone?: string[];
    message?: string[];
    privacy_policy_agreed?: string[];
  };
};

export const contactApiClient = {
  create: async (
    data: ContactCreateRequest,
  ): Promise<ApiResult<ContactCreateResponse, ContactCreateErrorResponse>> => {
    return await axiosClient.post('/company/contacts', data);
  },
};
